<template>
  <div class="hello">
    <div class="contentTop">
       <img src="../assets/logo.png" alt="" class="iconLogo">
       <div class="logoText">
          <div class="logoText1">双超家政</div>
          <div class="logoText2">家政保洁服务，高品质可信赖</div>
       </div>
    </div>
    <div class="conentBottom">
        <div class="bottomT">
          <div class="bottomT1">O2O家政<span style="color:#333333;">服务平台</span></div>
          <div class="bottomT2">保洁、保姆、月嫂、育儿嫂...</div>
          <img src="../assets/ios.png" alt="" class="logo" @click="getVersion(1)">
          <img src="../assets/ios.png" alt="" class="logo" @click="getVersion(2)">
        </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods:{
      getVersion(x){
           var ua = window.navigator.userAgent.toLowerCase();
            //微信
          if(ua.match(/MicroMessenger/i) == 'micromessenger'){
            //提示在外部浏览器打开
          }
          //非微信浏览器
          else{
            if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
                var loadDateTime = new Date();
                window.setTimeout(function() {
                  var timeOutDateTime = new Date();
                  if (timeOutDateTime - loadDateTime < 5000) {
                    window.location = "";  //ios下载地址
                  } else {
                      window.close();
                  }
                },2000);
                window.location = "weibo://"; //ios提供打开协议
              }
              else if (navigator.userAgent.match(/android/i)) {
                try {
                  window.location = 'weibo://';  //android提供打开协议
                  setTimeout(function(){
                  window.location= "";    //android下载地址
                },500);
                } catch(e) {}
            }
          }
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .hello{
    width:100%;
    height:100vh;
  }
  .contentTop{
    width:calc(100% - 20px);
    height:auto;
    background: #FFFFFF;
    padding:50px 10px;
    display:flex;
    align-items:center;
  }
  .iconLogo{
    width:50px;
    height:50px;
  }
  .logoText{
    margin-left:15px;
  }
  .logoText1{
    font-size: 20px;
    font-weight: 500;
    color: #333333;
  }
  .logoText2{
    font-size:14px;
    font-weight:400;
    color: #666666;
    margin-top:10px;
  }


  .conentBottom{
    width:100%;
    height:calc(100vh - 155px);
    background-image: url('../assets/bg.png');
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .bottomT{
    padding:80px 32px;
  }
  .bottomT1{
font-size: 26px;
font-family: SourceHanSansCN-Bold, SourceHanSansCN;
font-weight: bold;
color: #FF3D00;
  }
  .bottomT2{
    
font-size:19px;
font-family: SourceHanSansCN-Normal, SourceHanSansCN;
font-weight: 400;
color: #666666;
margin-top:20px;
  }
  .logo{
    width:180px;
    height:66px;
    margin-top:25px;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue